var $ee05965cd486c1dc$exports = {};
$ee05965cd486c1dc$exports = {
    "invalidSelection": (args, formatter)=>`Selected ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} unavailable.`
};


export {$ee05965cd486c1dc$exports as default};
//# sourceMappingURL=en-US.mjs.map
